// import React, { useState } from "react";

// const CustomToggle = ({
//   value,
//   options = ["On", "Off"], //
//   onChange,
// }) => {
//   return (
//     <div
//       className={`w-14 h-5 flex relative  gap-1 p-[2px] rounded-full  border border-gray-300  focus:outline-none cursor-pointer ${
//         value ? "bg-success-500" : "bg-danger-500"
//       }`}
//       onClick={() => {
//         onChange(!value);
//       }}
//     >
//       <div
//         className={`select-none text-xs px-1 w-full flex items-center text-white ${
//           value ? "justify-end" : "justify-start"
//         }`}
//       >
//         {value ? options[0] : options[1]}
//       </div>
//       <div
//         className={`w-4 h-4 bg-white rounded-full absolute  top-1/2 translate-y-[-50%] ${
//           value ? "left-[2px]" : "right-[2px]"
//         }`}
//       />
//     </div>
//   );
// };

// export default CustomToggle;

import React from "react";
import { motion } from "framer-motion";

const CustomToggle = ({
  value = true,
  options = ["On", "Off"],
  onChange = () => {}, // Default to empty function for safety
  size = "sm", //xs, xs-sm, sm, md, lg, xl
}) => {
  console.log("value",value);
  const sizeStyles = {
    xs: "w-12 h-5",
    "xs-sm": "w-14 h-5",
    sm: "w-14 h-6",
    md: "w-16 h-6",
    lg: "w-20 h-8",
    xl: "w-24 h-8",
  };
  const knobSizeStyles = {
    xs: "w-3 h-3",
    "xs-sm": "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-7 h-7",
  };

  const valueSizeStyles = {
    xs: "text-[10px]",
    "xs-sm": "text-xs",
    sm: "text-xs",
    md: "text-xs",
    lg: "text-md",
    xl: "text-md",
  };

  const knobAnimationStyles = {
    xs: {
      x: !value ? 0 : 30,
    },
    "xs-sm": {
      x: !value ? 0 : 34,
    },
    sm: {
      x: !value ? 0 : 30,
    },
    md: {
      x: !value ? 0 : 38,
    },
    lg: {
      x: !value ? 0 : 50,
    },
    xl: {
      x: !value ? 0 : 62,
    },
  };

  return (
    <motion.div
      className={`${sizeStyles[size]} overflow-hidden flex items-center relative gap-1 p-[2px] rounded-full border border-gray-300 focus:outline-none cursor-pointer`}
      // Animate background color
      animate={{
        backgroundColor: value ? "#18a605" : "#e20202", // success-500 and danger-500 (Tailwind colors)
      }}
      transition={{ duration: 0.2 }}
      onClick={() => {
        if (typeof onChange === "function") {
          onChange(!value);
        } else {
          console.warn("onChange is not a function");
        }
      }}
    >
      <div
        className={`absolute left-0 select-none  px-2 w-full flex items-center text-white text-nowrap ${
          !value ? "justify-end" : "justify-start"
        }
        ${valueSizeStyles[size]}
        `}
      >
        {/* {value ? options[0] : options[1]} */}
        {value ? "On" : "Off"}
      </div>
      <motion.div
        className={`${knobSizeStyles[size]} bg-white rounded-full absolute shadow-sm`}
        // Animate the circle's position
        animate={{
          ...knobAnimationStyles[size], // Adjust based on toggle width (14 * 2 - padding - circle width)
        }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 20,
        }}
      />
    </motion.div>
  );
};

export default CustomToggle;
